module.exports = __webpack_public_path__ + "img/Group 408.f5ea915e.svg";